export default "/images/43727039682342f479a63f4d5e9c1dda.avif";